/*
 * @Author: 80351408 vito.zeng@oppo.com
 * @Date: 2023-09-06 19:16:22
 * @LastEditors: 80351408 vito.zeng@oppo.com
 * @LastEditTime: 2023-10-16 20:50:05
 * @FilePath: \sns-user-frontend\public\regPush.js
 * @Description: 注册push
 */

import { v4 as uuidv4 } from "uuid";
import http from "@/service";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { windowFocused } from "@/hooks/windowState";

const check = () => {
  // console.log("check");
  // console.log(!("serviceWorker" in navigator));
  // console.log(!("PushManager" in window));
  // console.log(!("Notification" in window));
  if (
    !("serviceWorker" in navigator) ||
    !("PushManager" in window) ||
    !("Notification" in window)
  ) {
    return false;
  }
  return true;
};

const initFcm = () => {
  const config = JSON.parse(import.meta.env.VITE_FIREBASE_CONFIG);
  const app = initializeApp(config);
  // console.log(app);
  return getMessaging(app);
};

const getFirebaseToken = () => {
  const firebasePublicKey = import.meta.env.VITE_FIREBASE_PUBLIC_KEY;
  const messaging = initFcm();
  // console.log(messaging);
  const scope = window.location.origin + '/';
  navigator.serviceWorker.register(scope + "sw.js", {scope: scope});
  getToken(messaging, { vapidKey: firebasePublicKey })
    .then((currentToken) => {
      if (currentToken) {
        // console.log("Firbase token is not empty", currentToken);
        saveTokenToServer(currentToken);
      } else {
        // if token is empty
        // console.log("Firbase token is empty");
      }
    })
    .catch((err) => {
      // console.log(err);
    });

  onMessage(messaging, (payload) => {
    // console.log("Message received. ", payload);
    const shown = getCookie(payload.messageId);
    // console.log("shown = ", shown);
    // console.log("windowFocused = ", windowFocused.value);
    if (shown || !windowFocused.value) {
      // console.log("message is shown");
      return;
    }

    setCookie(payload.messageId, true, 10);
    var notificationInfo = {};

    if (!payload.hasOwnProperty("notification")) {
      const dataBody = JSON.parse(payload.data.body);
      const notificationTitle = dataBody.title;
      const notificationOptions = {
        body: dataBody.content,
        icon: dataBody.icon,
        image: dataBody.image,
        data: { url: dataBody.url },
      };
      notificationInfo = {
        title: notificationTitle,
        options: notificationOptions,
      };
    } else {
      notificationInfo = {
        title: payload.notification.title,
        options: {
          body: payload.notification.body,
          icon: payload.notification.icon,
          image: payload.notification.image,
          data: { url: payload.fcmOptions.link, messageId: payload.messageId },
        },
      };
    }
    try {
      const notification = new Notification(
        notificationInfo.title,
        notificationInfo.options
      );
      notification.onclick = function (event) {
        event.preventDefault();
        const url = event.target.data.url;
        window.open(url, "_blank")
        event.notification.close()
      };
    } catch (e) {
      navigator.serviceWorker.ready.then((registration) => {
        // console.log(registration);
        registration.showNotification(
          notificationInfo.title,
          notificationInfo.options
        );
      });
    }
  });
};
const requestNotificationPermission = () => {
  if (Notification.permission === "granted") {
    getFirebaseToken();
  } else if (Notification.permission === "default") {
    //请求通知权限
    Notification.requestPermission().then(function (permission) {
      if (permission === "granted") {
        getFirebaseToken();
      } else if (permission === "denied") {
        // console.log("Notification permission has been denied");
      }
    });
  } else {
    // console.log("Notification permission has been denied");
  }
};

const saveTokenToServer = (token) => {
  getUniqueId();
  const params = {
    regId: token,
  };
  http.saveTokenToServer(params);
};

const getUniqueId = () => {
  let uniqueId = localStorage.getItem("uniqueId");
  if (uniqueId == null) {
    uniqueId = uuidv4();
    uniqueId = uniqueId.replace(/\-/g, "");
    localStorage.setItem("uniqueId", uniqueId);
  }
  return uniqueId;
};

function setCookie(name, value, seconds) {
  let expires = "";
  if (seconds) {
    let date = new Date();
    date.setTime(date.getTime() + seconds * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + value + expires + "; path=/";
}

function getCookie(name) {
  let cookieName = name + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let cookies = decodedCookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i].trim();
    if (cookie.indexOf(cookieName) === 0) {
      return cookie.substring(cookieName.length, cookie.length);
    }
  }
  return "";
}

export function regPush() {
  const brand = import.meta.env.VITE_BRAND;
  const country = import.meta.env.VITE_COUNTRY;
  // console.log("brand: " + brand);
  // console.log("country: " + country);

  if ((brand === "ONEPLUS" && country === "PARIS") || brand === "OPPO") {
    if (check()) {
      // console.log("check ok");
      requestNotificationPermission();
    }
  }
}
